module.exports = __webpack_public_path__ + "static/media/undraw_outer_space_3v6n.5a0b10fd.svg";